import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "opModal alertModal p-3 text-center" }
const _hoisted_2 = { class: "logoIcon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "header mt-3"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "body mt-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-3 mw-700" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.$store.state.consts.projectConfig.logoUrl
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "midTitle",
            innerHTML: _ctx.title
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-block btn-primary noShadow",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
        }, [
          _createElementVNode("span", { innerHTML: _ctx.okText }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}